<style>
/* Tablas responsivas globales */
@media (max-width: 900px) {
  table {
    display: block !important;
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
    margin-bottom: 1rem !important;
  }
  thead, tbody, tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  th, td {
    word-break: break-word;
    font-size: 0.95rem;
    padding: 0.5rem 0.3rem;
  }
}
</style>
<template>
  <div id="app">
    <Login v-if="!isLoggedIn" @login-success="onLoginSuccess" />
    <div v-else>
      <HeaderNav @toggle-sidebar="toggleSidebar" />
      <div class="main-layout">
        <SidebarMenu 
          ref="sidebarMenu"
          @navigate="navigate" 
        />
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import Login from './layouts/Login.vue';
import Home from './layouts/Home.vue';
import SidebarMenu from './partials/SidebarMenu.vue';
import HeaderNav from './partials/HeaderNav.vue';
import UsuariosView from './views/Usuarios.vue';
import RolesView from './views/Roles.vue';
import TalleresView from './views/Talleres.vue';
import HorariosView from './views/Horarios.vue';
import AlumnosView from './views/Alumnos.vue';
import ReporteGeneralView from './views/ReporteGeneral.vue';

export default {
  name: 'App',
  components: {
    Login,
    Home,
  SidebarMenu,
  HeaderNav,
    UsuariosView,
    RolesView,
    TalleresView,
    HorariosView,
    AlumnosView,
    ReporteGeneralView
  },
  data() {
    return {
      isLoggedIn: false
    };
  },
  methods: {
    onLoginSuccess() {
      this.isLoggedIn = true;
      this.$router.push('/');
    },
    toggleSidebar() {
      if (this.$refs.sidebarMenu) {
        this.$refs.sidebarMenu.toggleSidebar();
      }
    },
    navigate(view) {
      const map = {
        usuarios: '/usuarios',
        roles: '/roles',
        talleres: '/talleres',
        horarios: '/horarios',
        alumnos: '/alumnos',
        pagos: '/pagos',
        coordinacion: '/coordinacion',
        reportegeneral: '/reportegeneral',
        'asistencia-reporte': '/asistencia-reporte',
        mitaller: '/mitaller',
        mitaller2: '/mitaller2',
        mitaller3: '/mitaller3'
      };
      
      this.$router.push(map[view] || '/');
    }
  },
  created() {
    // Si hay token, mantener login
    if (localStorage.getItem('token')) {
      this.isLoggedIn = true;
    }
  }
};
</script>

<style>
body {
  background: #f5f6fa;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin: 0;
  overflow-x: hidden;
}
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  min-height: 100vh;
}
.main-layout {
  display: flex;
  min-height: calc(100vh - 64px);
  margin-top: 64px;
}
.main-content {
  flex: 1;
  margin-left: 280px;
  padding: 2rem;
  background: #f5f6fa;
  min-height: calc(100vh - 64px);
  transition: margin-left 0.3s ease;
}

/* Media queries para responsivo */
@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .main-layout {
    margin-top: 60px;
  }
  
  .main-content {
    padding: 0.5rem;
  }
}
</style>
